import { Component, Input, OnInit } from '@angular/core';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { UserService } from 'app/Shared/Services/user.service';
import { CaisServiceService } from '../../cais-service.service';
import {CommonModule, NgClass, LowerCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatListItem } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TableModule } from 'primeng/table';
import { Select } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
    selector: 'app-ltid-details',
    templateUrl: './ltid-details.component.html',
    imports: [CommonModule, NgClass, LowerCasePipe, FormsModule, ReactiveFormsModule, Select, DatePickerModule, TableModule, MatTooltipModule, MatListItem, MatDividerModule],
    providers: [ConstantService, UserService],
    styleUrls: ['./ltid-details.component.scss']
})
export class LtidDetailsComponent implements OnInit {
  @Input('LTIDGridColumns') LTIDGridColumns: any;
  
  constructor(public caisServiceService: CaisServiceService,
    public constantService: ConstantService,
    public userService:UserService) { 

    }

  ngOnInit() {

  }

  addLTID() {
    this.caisServiceService.LTIDDataSet.push({ largeTraderID: '', ltidEffectiveDate: '', ltidEndDate: '', ltidEndReason: '' });
  }

  removeLTID(rowIndex: any) {
    this.caisServiceService.LTIDDataSet.splice(rowIndex, 1)
  }

}
